export default "__VITE_ASSET__DgJFqitT__"